import React from 'react'

import styles from './Popup.module.css'

class Popup extends React.Component {
  constructor(props) {
    super(props)
    this.escFunction = this.escFunction.bind(this)

    this.state = {
      menu: props.menu ? props.menu : 0,
    }
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.closePopup()
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }

  render() {
    if (
      !this.props.data.Nmbetr ||
      !this.props.data.NmbetrInfo ||
      !this.props.data.zusatzGemeinden
    )
      return null

    return (
      <div className={styles.box}>
        <div className={styles.header}>
          <span>{this.props.data.gemeinde.name}</span>
          <div className={styles.x} onClick={() => this.props.closePopup()}>
            <svg width="20" height="20">
              <line
                x1="5"
                y1="5"
                x2="15"
                y2="15"
                stroke="#BE0021"
                strokeWidth="3"
                strokeLinecap="butt"
              />
              <line
                x1="15"
                y1="5"
                x2="5"
                y2="15"
                stroke="#BE0021"
                strokeWidth="3"
                strokeLinecap="butt"
              />
            </svg>
          </div>
        </div>

        <div className={styles.text}>
          <span>
            Website:{' '}
            <a
              href={
                this.props.data.zusatzGemeinden.edges[0].node.Website_Gemeinde
              }
            >
              {this.props.data.zusatzGemeinden.edges[0].node.Website_Gemeinde}
            </a>
          </span>
          <br />
          <span>
            Telefonnummer Gemeinde:{' '}
            <a
              href={`tel:${this.props.data.zusatzGemeinden.edges[0].node
                .Telefon_Gemeinde}`}
            >
              {this.props.data.zusatzGemeinden.edges[0].node.Telefon_Gemeinde}
            </a>
          </span>
          <br />
          <hr />
          <table className={styles.indicator_10_14}>
            <tbody>
              <tr>
                <th>Anzahl der Betreuungseinrichtungen</th>
                <td />
              </tr>
              <tr>
                <td>Nachmittagsbetreuung in NMS</td>
                <td>
                  {this.props.data.Nmbetr.edges[0].node.NMS_getrennt +
                    this.props.data.Nmbetr.edges[0].node.NMS_verschr || 0}
                </td>
              </tr>
              <tr>
                <td>Nachmittagsbetreuung in Sonderschule</td>
                <td>
                  {this.props.data.Nmbetr.edges[0].node.ASO_getrennt || 0}
                </td>
              </tr>
              <tr>
                <td>Nachmittagsbetreuung in AHS Unterstufe</td>
                <td>{this.props.data.Nmbetr.edges[0].node.AHS_ja || 0}</td>
              </tr>
              <tr>
                <td>Nachmittagsbetreuung in Polytechnische Schule</td>
                <td>{this.props.data.Nmbetr.edges[0].node.poly_ja || 0}</td>
              </tr>
            </tbody>
          </table>
          {this.props.data.NmbetrInfo.edges
            .filter(
              info =>
                info.node.Nachmittagsbetreuung == 'ja' ||
                info.node.Nachmittagsbetreuung == 'Nachmittagsbetreuung'
            )
            .map((info, index) => (
              <div key={index}>
                <hr />
                <table className={styles.facility_10_14}>
                  <tbody>
                    <tr>
                      <th>{info.node.Schule}</th>
                    </tr>
                    <tr>
                      <td>
                        {info.node.Adresse.split(',').length > 1 ? (
                          <div>
                            {info.node.Adresse.split(',')[0]}
                            <br />
                            {info.node.Adresse.split(',')[1]}
                          </div>
                        ) : (
                          info.node.Adresse
                        )}
                      </td>
                      <td style={{ verticalAlign: 'bottom' }}>
                        Schulische Tagesbetreuung:{' '}
                        {info.node.Nachmittagsbetreuung ==
                        'Nachmittagsbetreuung'
                          ? 'ja'
                          : info.node.Nachmittagsbetreuung}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Telefonnummer:{' '}
                        <a href={`tel:${info.node.Telefonnummer}`}>
                          {info.node.Telefonnummer}
                        </a>
                      </td>
                      <td>
                        Art der Schulform: {info.node.Nachmittagsbetreuung_Form}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))}
        </div>
      </div>
    )
  }
}

export default Popup



// WEBPACK FOOTER //
// ./src/components/Popup_10_14.js